/*
 * @Author: hulihua7
 * @Email: hulihua7@jd.com
 * @Date: 2021-02-02 14:21:11
 * @Last Modified by: zhouzhuoxin
 * @Last Modified time: 2021-08-27 08:48:00
 * @Description: 活动类型-正式活动、测试活动
 */ export const ACTIVITY_TYPES = [
  {
    title: '正式活动',
    val: 1,
  },
  {
    title: '测试活动',
    val: 0,
  },
];

export const ACTIVITY_TYPES_MAP = {};

ACTIVITY_TYPES.forEach((item) => {
  ACTIVITY_TYPES_MAP[item.val] = item.title;
});

export default ACTIVITY_TYPES;
